var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 91 91",
    width: "91px",
    height: "91px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.241,18.4c-10.083,0.143-37.69,0.711-41.348,1.254c-3.732,0.553-2.475,5.955,0.842,6.211 c7.627,0.59,60.263,0.645,57.86,0.645c5.303,0,5.311-8.24,0-8.24C77.901,18.27,62.353,18.34,58.241,18.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.241,41.511c-10.083,0.143-37.69,0.711-41.348,1.254c-3.732,0.553-2.475,5.955,0.842,6.211 c7.627,0.59,60.263,0.645,57.86,0.645c5.303,0,5.311-8.24,0-8.24C77.901,41.38,62.353,41.45,58.241,41.511z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.241,64.621c-10.083,0.143-37.69,0.711-41.348,1.254c-3.732,0.553-2.475,5.955,0.842,6.211 c7.627,0.59,60.263,0.645,57.86,0.645c5.303,0,5.311-8.24,0-8.24C77.901,64.49,62.353,64.561,58.241,64.621z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.d83f51ea4cf78f927c6bed440ee32e88.svg";
export { ForwardRef as ReactComponent };